<template>
  <el-col :span="24" id="billabletype">
    <el-row type="flex">
      <el-col :span="24">
        <el-row type="flex" justify="start" align="middle" id="billabletype-header">
          <HeaderInfoText :colspan="9" title="BILLABLE TYPES" :meta="meta" :selection="selection" />
          <el-col :span="6">
            <el-row type="flex" justify="center" v-if="meta.count > 20">
              <el-pagination
                layout="prev, pager, next, jumper"
                :total="meta.count"
                :page-size="20"
                v-model:current-page="currentPage">
              </el-pagination>
            </el-row>
          </el-col>
          <el-col :span="9" class="h-padded right-aligned-col">
            <el-button type="primary" icon="plus" @click="createNewModel" />
          </el-col>
        </el-row>
        <el-row type="flex" justify="end" align="middle">
          <el-col :span="24">
            <el-table
              v-if="meta.count && !changingPage"
              id="billabletype-table"
              :ref="`${endpoint}Table`"
              :data="pageData"
              border
              style="width: 100%; z-index: 0;"
              @select="handleTableSelectionChange"
              @select-all="handleTableSelectionChange"
              :row-class-name="tableRowClassName">
              <el-table-column prop="code" label="Code" align="center" width="120">
                <template v-slot="scope">
                  <el-row type="flex" justify="center">
                    <a class="link-mock" @click="editExistingModel(scope.row.id)">
                      {{ scope.row.code }}
                    </a>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Name" align="start">
                <template v-slot="scope">
                  <el-row type="flex" justify="start">
                    <a class="link-mock" @click="editExistingModel(scope.row.id)">
                      {{ scope.row.name }}
                    </a>
                  </el-row>
                </template>
              </el-table-column>
              <el-table-column prop="default_markup_amount_decimal" label="Default Markup Amount" align="center" width="300">
                <template v-slot="scope">
                  {{ scope.row.default_markup_amount_decimal ? `$${formatAmountLocale(scope.row.default_markup_amount_decimal)}` : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="default_markup_rate" label="Default Markup Rate" align="center" width="300">
                <template v-slot="scope">
                  {{ scope.row.default_markup_rate ? `${scope.row.default_markup_rate} %` : '' }}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="editMode.active ? `Edit Billable Type` : 'Create New Billable Type'"
      width="45%"
      v-model="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false">
      <NewEntityForm
        v-if="editMode.active"
        :fields="fields"
        v-model:form="form"
        :idPrefix="'a-'"
        ref="form"
        @formChanged="trackFormChange"
      />
      <NewEntityForm
        v-else
        :fields="fields"
        v-model:form="form"
        :idPrefix="'a-'"
        ref="form"
        @formChanged="trackFormChange"
      />
      <template v-slot:footer><span class="dialog-footer">
        <el-button :disabled="saving || !!updating" @click="closeFormModal">Cancel</el-button>
        <el-button :loading="saving || !!updating" type="primary" @click="submitForm">Submit</el-button>
      </span></template>
    </el-dialog>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { payload } from '@/components/RouteComponents/Billabletypes/actionPayload'
  import store from '@/store/store'
  import NewEntityForm from '@/components/NewEntityForm.vue'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import getUniqueValues from '@/utils/helpers/GetUniqueValues'
  import { systemViewMixins } from '@/Mixins/SystemViewMixins'
  import { arSystemViewMixins } from '@/Mixins/ArSystemViews'
  import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
  import { formatAmount } from '@/utils/helpers/AmountFormatter'

  export default {
    components: {
      NewEntityForm,
      HeaderInfoText
    },
    mixins: [ systemViewMixins, arSystemViewMixins ],
    data () {
      return {
        tableHeight: 1000,
        showFilters: true,
        batchUpdateOptions: [
          { id: 0, text: 'Delete selected Billable Types' }
        ],
        batchUpdateSelection: null,
        selection: [],
        dialogFormVisible: false,
        changingPage: false,
        editMode: { active: false, modelId: null },
        hiddenFields: []
      }
    },
    methods: {
      getUniqueValues,
      formatAmountLocale (value) {
        return formatAmount(value)
      }
    },
    computed: {
      ...mapGetters({
        getAccountById: 'getAccountById',
        getVendorById: 'getVendorById'
      }),
      data () {
        return this.sortData(this.$store.getters.getAllBillabletype)
      },
      pageData () {
        return this.meetsFilterCriteria(this.data).slice((this.currentPage - 1) * 20, this.currentPage * 20)
      },
      meta () {
        return { count: this.meetsFilterCriteria(this.data).length, shown: this.pageData.length }
      }
    },
    watch: {
      pageData () {
        if (this.restoreTableSelection && typeof this.restoreTableSelection === 'function') {
          this.restoreTableSelection()
        }
      }
    },
    /**
     * Pre-route enter logic.
     * @param to
     * @param from
     * @param next
     */
    async beforeRouteEnter (to, from, next) {
      let initPromises = []
      const fieldsAlreadyExist = !typeof store.getters.getResourceFieldsByEndpoint(payload.endpoint) === 'undefined'
      if (!fieldsAlreadyExist) {
        initPromises.push(store.dispatch('fetchOptions', payload))
      }
      try {
        await Promise.all(initPromises)
        if (from.path !== '/') {
          let dataLoader = new DataLoader(store, [ payload ], true, 200)
          await dataLoader.loadData()
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    },
    created () {
      this.endpoint = payload.endpoint
      this.moduleName = payload.moduleName
      this.payload = payload
      this.generateForm()
    }
  }
</script>

<style scoped>
  #billabletype-header {
    border-bottom: 1px solid lightgray;
  }
  .h-padded {
    padding: 0 12px;
  }
  .right-aligned-col {
    text-align: right;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
</style>
